"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimestampFormatter = TimestampFormatter;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _deChLocale = _interopRequireDefault(require("de-ch-locale"));

var _d3TimeFormat = require("d3-time-format");

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Swiss German locale – use this to create new formats.
 * @private
 */
var _swissLocale = (0, _d3TimeFormat.timeFormatLocale)(_deChLocale.default);

var fullDateAndTimeFormatter = _swissLocale.format('%x, %H:%M Uhr');
/**
 * Provides a formatted timestamp, with an optional prefix. Modeled after the common article suffix on tagesanzeiger.ch
 * articles, it will return something like "Erstellt: 25.07.2017, 11:47 Uhr" with the appropriate prefix.
 *
 * @example
 * import { TimestampFormatter } from '@ta-interaktiv/react-publication-date'
 *
 * function Component (props) {
 *   return (
 *     <TimestampFormatter prefix='Erstellt:' timestamp={1500986249} />
 *   )
 * }
 *
 * @param {object} props
 * @param {number} [props.timestamp] A UNIX timestamp, in seconds. If not provided, the element will not render.
 * @param {string} [props.prefix] A string that precedes the date, like "Erstellt:" or "Aktualisiert:"
 *
 * @see {@link NameValueItem} for additional className parameters to be passed into this component.
 */


function TimestampFormatter(props) {
  var timestamp = props.timestamp,
      _props$prefix = props.prefix,
      prefix = _props$prefix === void 0 ? '' : _props$prefix;

  if (timestamp) {
    return _react.default.createElement(_index.NameValueItem, _extends({}, props, {
      name: prefix,
      value: fullDateAndTimeFormatter(timestamp * 1000)
    }));
  } else {
    return null;
  }
}

var _default = TimestampFormatter;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-publication-info/dist/timestamp-formatter.js
// module id = 38
// module chunks = 0